import * as React from "react";
import { getEventTitle, getTagNumber } from "../../../../helpers";
import { PreliveOutrightHeading } from "../PreliveOutrightHeading";
import { PreliveOutright } from "../PreliveOutright";
import { ViewAllBtn } from "../ViewAllBtn";
export class PreliveOutrightWrap extends React.Component {
    constructor(props) {
        super(props);
        this.componentPrefix = "prelive-outright";
        this.state = {
            isExpanded: this.props.isExpanded
        };
    }
    toggleSelections(e) {
        e.preventDefault();
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }
    getViewAllOnClick() {
        return this.props.viewAllProps.onClick || (e => this.toggleSelections(e));
    }
    getViewAllText() {
        return this.state.isExpanded
            ? this.props.dict.HideAllOutrights
            : this.props.dict.ViewAllOutrights;
    }
    getNumberOfSelectionsToShow() {
        return this.state.isExpanded
            ? this.props.markets[0].selections.length
            : this.props.numberOfSelectionsToShow;
    }
    getViewAllProps() {
        return {
            linkUrl: this.props.viewAllProps.linkUrl || "",
            text: this.getViewAllText(),
            onClick: this.props.viewAllProps.onClick || this.getViewAllOnClick()
        };
    }
    renderOutright() {
        const details = Object.assign(Object.assign({}, this.props), { numberOfSelectionsToShow: this.getNumberOfSelectionsToShow(), isExpanded: this.state.isExpanded });
        return React.createElement(PreliveOutright, Object.assign({}, details),
            React.createElement(ViewAllBtn, Object.assign({}, this.getViewAllProps())));
    }
    render() {
        if (!this.props.markets.length) {
            return React.createElement(React.Fragment, null);
        }
        const title = getEventTitle(this.props.event, this.props.markets[0], this.props.dict.EachWayTag);
        const tagNumber = getTagNumber(this.props.event.mbnIcon);
        return this.props.showHeadingNames
            ? React.createElement(PreliveOutrightHeading, { key: `subheading-content-${this.props.event.id}`, id: this.props.event.id, name: title, mbnTag: tagNumber, componentPrefix: this.componentPrefix }, this.renderOutright())
            : this.renderOutright();
    }
}
//# sourceMappingURL=PreliveOutrightWrap.js.map